import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Dropdown, Spin } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { Button } from 'ui/styled';
import { Menu, Footer, StyledButton, Title } from './styled';
var FilterDropdown = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.loading, loading = _c === void 0 ? false : _c, _d = _a.title, title = _d === void 0 ? 'Filter' : _d, content = _a.content, _e = _a.hasDefaultValue, hasDefaultValue = _e === void 0 ? false : _e, onReset = _a.onReset, onSave = _a.onSave, _f = _a.onCancel, onCancel = _f === void 0 ? function () { } : _f, _g = _a.dataTest, dataTest = _g === void 0 ? 'FilterDropdown' : _g;
    var _h = useState(false), open = _h[0], setOpen = _h[1];
    var _j = useState(hasDefaultValue), changed = _j[0], setChanged = _j[1];
    var closeMenu = function () { return setOpen(false); };
    var handleReset = function () {
        onReset();
        setChanged(false);
        closeMenu();
    };
    var handleCancel = function () {
        onCancel();
        closeMenu();
    };
    var handleSave = function () {
        onSave();
        closeMenu();
        setChanged(true);
    };
    var menu = function () { return (_jsxs(Menu, { selectable: false, "data-test": "".concat(dataTest, "Content"), children: [content, _jsxs(Footer, { children: [changed && (_jsx(Button, { btnsize: "small", btntype: "danger", onClick: handleReset, margin: "0 10px 0 0", minwidth: "80px", "data-test": "dropdownResetButton", children: "Reset" })), _jsx(Button, { btnsize: "small", onClick: handleCancel, margin: "0 10px 0 0", minwidth: "80px", "data-test": "dropdownCancelButton", children: "Cancel" }), _jsx(Button, { btntype: "primary", btnsize: "small", onClick: handleSave, minwidth: "80px", "data-test": "dropdownSaveButton", children: "Apply" })] })] })); };
    return (_jsx(Spin, { spinning: loading, children: _jsx(Dropdown, { open: open, disabled: disabled, onOpenChange: setOpen, popupRender: menu, placement: "bottomLeft", trigger: ['click'], children: _jsxs(StyledButton, { "data-test": dataTest, children: [_jsx(Title, { children: title }), _jsx(DownOutlined, {})] }) }) }));
};
export default FilterDropdown;
